import { createReducer } from '@reduxjs/toolkit'

import { getProductsSummaryProductAdsTableColumnsConfig } from 'configuration/tables/productAdTables'
import {
    DATES,
    REGIONS,
    COUNTRIES,
    BRANDS,
    PRODUCT_AD_STATES,
    PRODUCT_TITLE,
    PRODUCT_ASINS,
    PRODUCT_TITLES,
    PRODUCT_NUMBER_OF_ITEMS,
    LABELS,
    METRIC_FILTERS,
    PORTFOLIOS,
    FACT_TYPES,
    ADVANCED_TEXT,
    ADVANCED_PRODUCT_TITLE,
    CAMPAIGN_STATES,
} from 'const/filters'
import { FILTERS, FILTER_SETTINGS } from 'const/reducerKeys'
import {
    ENABLED,
    CAMPAIGN_STATES as CAMPAIGN_STATES_OPTIONS,
    PRODUCT_AD_STATES as PRODUCT_AD_STATES_OPTIONS,
} from 'const/resourceStates'
import { serializeColumns } from 'helpers/tables'
import { defaultTab, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    ...defaultTab,
    [FILTERS]: {
        [PRODUCT_TITLE]: null,
        [FACT_TYPES]: [],
        [REGIONS]: [],
        [COUNTRIES]: [],
        [BRANDS]: [],
        [PORTFOLIOS]: [],
        [PRODUCT_ASINS]: [],
        [PRODUCT_AD_STATES]: [
            {
                value: ENABLED,
                label: PRODUCT_AD_STATES_OPTIONS[ENABLED],
            },
        ],
        [PRODUCT_TITLES]: [],
        [PRODUCT_NUMBER_OF_ITEMS]: [],
        [LABELS]: [],
        [ADVANCED_TEXT]: [],
        [METRIC_FILTERS]: [],
        [ADVANCED_PRODUCT_TITLE]: [],
        [CAMPAIGN_STATES]: [
            {
                value: ENABLED,
                label: CAMPAIGN_STATES_OPTIONS[ENABLED],
            },
        ],
    },
    [FILTER_SETTINGS]: {
        anchored: [PRODUCT_TITLE, DATES, FACT_TYPES],
        order: [
            METRIC_FILTERS,
            REGIONS,
            COUNTRIES,
            BRANDS,
            PORTFOLIOS,
            PRODUCT_ASINS,
            PRODUCT_AD_STATES,
            PRODUCT_TITLES,
            PRODUCT_NUMBER_OF_ITEMS,
            LABELS,
            ADVANCED_TEXT,
            ADVANCED_PRODUCT_TITLE,
            CAMPAIGN_STATES,
        ],
        displayState: {
            [METRIC_FILTERS]: true,
            [REGIONS]: true,
            [COUNTRIES]: true,
            [BRANDS]: true,
            [PORTFOLIOS]: true,
            [PRODUCT_ASINS]: true,
            [PRODUCT_AD_STATES]: true,
            [PRODUCT_TITLES]: true,
            [PRODUCT_NUMBER_OF_ITEMS]: false,
            [LABELS]: true,
            [ADVANCED_TEXT]: true,
            [ADVANCED_PRODUCT_TITLE]: true,
            [CAMPAIGN_STATES]: true,
        },
        userAdded: [PRODUCT_AD_STATES, CAMPAIGN_STATES],
    },
    table: getDefaultTable(
        serializeColumns(getProductsSummaryProductAdsTableColumnsConfig())
    ),
}

export default createReducer(initialState, () => {})
